module.exports = __webpack_public_path__ + "static/media/co2.aa740d0a.svg";